import {
  ComponentBuilder,
  FunctionComponent
} from '../../component-builder/types';
import { DisplayConfigType } from 'formats/display/lib/config';
import { Component as SquaredComponent } from './component';
import { Component as RoundedComponent } from './rounded-close-button/component';

export class CloseButtonBuilder implements ComponentBuilder<DisplayConfigType> {
  isInjectable(adContext: AdContext, formatConfig: DisplayConfigType): boolean {
    return formatConfig?.closeBtn?.useCloseBtn;
  }

  build(
    adContext: AdContext,
    formatConfig: DisplayConfigType
  ): FunctionComponent {
    return formatConfig?.closeBtn?.type === 'rounded'
      ? RoundedComponent
      : SquaredComponent;
  }
}
